$(function () {
  
  var currentSlideIndex = 0;
  var gallery = $('.gallery');
  var imagesContainer = gallery.find('.gallery__carousel-images');
  var images = imagesContainer.children('.gallery__carousel-image');
  var arrowLeft = gallery.find('.gallery__carousel-arrow-left');
  var arrowRight = gallery.find('.gallery__carousel-arrow-right');
  var indicators = gallery.find('.carousel__indicator');
  
  // Define the click handlers
  arrowLeft.click(function () {
    var index = getPrevSlideIndex();
    displayImage(index)
    updateDots(index);
  });
  arrowRight.click(function () {
    var index = getNextSlideIndex();
    displayImage(index)
    updateDots(index);
  });
  indicators.click(function () {
    var index = $(this).index();
    displayImage(index)
    updateDots(index);
  });
  
  $(window).resize(function () {
    displayImage(currentSlideIndex);
  });
  
  function getNextSlideIndex() {
    if (currentSlideIndex === images.length - 1) {
      return 0;
    }
    
    return currentSlideIndex + 1;
  }
  
  function getPrevSlideIndex() {
    if (currentSlideIndex === 0) {
      return images.length - 1;
    }
    
    return currentSlideIndex - 1;
  }
  
  // Applies the correct 'left' property to the images container
  // to provide a sliding carousel effect.
  function displayImage(index) {
    var width = imagesContainer.width();
    imagesContainer.css('left', -(width * index));
    currentSlideIndex = index;
  }
  
  // Updates the 'selected' class for the dots.
  function updateDots(index) {
    indicators.removeClass('carousel__indicator--selected');
    $(indicators.get(index)).addClass('carousel__indicator--selected');
  }
  
});
